import { gatewayPhone } from "src/gateways/gatewayPhone";

export interface UsagePeriodSummaryItem {
  uid: string;
  phoneNumber: string;
  billingPeriod: string;
  services: Array<{
    serviceType: string;
    units: number;
    totalAmount: number;
    unitPrice?: number;
    averageUnitPrice?: number;
    description: string;
  }>;
  grandTotal: number;
  closedAt: string;
}

export interface UsagePeriodSummariesResponse {
  data: UsagePeriodSummaryItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

interface GetPeriodSummariesParams {
  phoneNumber: string;
  page?: number;
  limit?: number;
  services?: string;
}

export const getPeriodSummaries = async ({
  phoneNumber,
  page = 1,
  limit = 24,
  services,
}: GetPeriodSummariesParams): Promise<UsagePeriodSummariesResponse> => {
  const { data } = await gatewayPhone.get<UsagePeriodSummariesResponse>("/usage/period-summaries", {
    params: {
      phoneNumber,
      page,
      limit,
      ...(services ? { services } : {}),
    },
  });

  return data;
};
